module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2405269"
    }
  }, [_c('b', [_vm._v("BEEF-VEGETABLE SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2405769"
    }
  }, [_c('b', [_c('i', [_vm._v("An old-fashioned crowd-pleaser, this soup can be made a day ahead, but for the most vibrant color, stir in the peas just before serving. You’ll have plenty of soup here—the leftovers freeze well.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2407369"
    }
  }, [_c('b', [_vm._v("Prep: 30 minutes plus soaking beans Cook: 1 hour 45 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2408169"
    }
  }, [_vm._v("1 tablespoon vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2408469"
    }
  }, [_vm._v("2 pounds bone-in beef shank cross cuts, "), _c('br'), _vm._v(" each 2 inches thick, trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2409069"
    }
  }, [_vm._v("2 medium onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2409369"
    }
  }, [_vm._v("3 garlic cloves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2409669"
    }
  }, [_vm._v("⅛ teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2410669"
    }
  }, [_vm._v("4 large carrots, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2410969"
    }
  }, [_vm._v("2 stalks celery, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2411269"
    }
  }, [_vm._v("½ small head green cabbage (8 ounces), "), _c('br'), _vm._v(" cored and chopped (5 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2412569"
    }
  }, [_vm._v("4 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2413169"
    }
  }, [_vm._v("1 can (14½ ounces) beef broth or "), _c('br'), _vm._v(" 1¾ cups Brown Beef Stock")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2415469"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2415769"
    }
  }, [_vm._v("½ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2416769"
    }
  }, [_vm._v("½ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2417669"
    }
  }, [_vm._v("8 ounces dry large lima beans (1¼ cups), "), _c('br'), _vm._v(" soaked and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2419169"
    }
  }, [_vm._v("1 pound all-purpose potatoes (3 medium), "), _c('br'), _vm._v(" peeled and cut into 1-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2419769"
    }
  }, [_vm._v("1 can (14 to 16 ounces) tomatoes, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2420169"
    }
  }, [_vm._v("1 cup frozen whole-kernel corn")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2420469"
    }
  }, [_vm._v("1 cup frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2420769"
    }
  }, [_vm._v("¼ cup chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2421869"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In nonreactive 8-quart saucepot, heat oil over medium-high heat until very hot. Add beef, in batches, and cook until well browned, transferring meat to bowl as it is browned. Reduce heat to medium; add onions and cook, stirring, until tender, about 5 minutes. Stir in garlic and cloves and cook 30 seconds. Return beef to saucepot; add carrots, celery, cabbage, water, broth, salt, thyme, and pepper; heat to boiling. Reduce heat; cover and simmer until beef is tender, about 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2426169"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in 4-quart saucepan, combine beans and enough "), _c('i', [_vm._v("water to cover by 2 inches; ")]), _vm._v("heat to boiling over high heat. Reduce heat; cover and simmer until beans are just tender, about 30 minutes; drain.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2428269"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Add potatoes and beans to saucepot; heat to boiling. Cover and simmer 5 minutes. Stir in tomatoes with their juice; cover and simmer until potatoes are tender, about 10 minutes longer.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2430469"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" With slotted spoon, transfer beef to cutting board. Cut beef into ½-inch pieces, discarding bones and gristle. Return beef to saucepot and add frozen corn and peas; heat through. Spoon into bowls and sprinkle with parsley. Makes about 15½ cups or 8 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2434969"
    }
  }, [_vm._v("Each serving: About 278 calories, 24g protein, 35g carbohydrate, 6g total fat (1g saturated), 30mg cholesterol, 955mg sodium.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e2437669"
    }
  }, [_c('b', [_vm._v("STORING SOUPS AND STOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "l.jpg",
      "src": "Images/l.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2438369"
    }
  }, [_c('b', [_vm._v("•")]), _vm._v(" Soup and stock should be quickly cooled before storing in the refrigerator or freezer. To cool down a pot of soup or stock, place the pot in a sink filled with ice water and let stand, stirring until tepid. Or pour the soup into small containers and cool for thirty minutes, then refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2441269"
    }
  }, [_c('b', [_vm._v("•")]), _vm._v(" Stocks and most soups freeze well in airtight containers for up to three months. Be sure to leave at least ½ inch of headspace to allow for expansion. Freezing may diminish some of a soup’s flavor, so be sure to taste the soup and adjust the seasoning before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e2444769"
    }
  }, [_c('b', [_vm._v("•")]), _vm._v(" Soup enriched with cream, yogurt, or eggs cannot be frozen because it will curdle when reheated; the soup base can be frozen, however. Prepare the soup just up to the point of adding the cream, yogurt, or eggs. Freeze like any other soup, then thaw and reheat, adding the enrichment at the last minute—just long enough to heat through. Do not allow the soup to boil, or it may curdle.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f848b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c73_r1.vue
// module id = 285
// module chunks = 0